import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { partnerPortalApi } from '../../api/partnerPortal';

export function PartnerRegisterPage() {
  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);
  const { register, handleSubmit, formState: { isSubmitting } } = useForm<{ email: string; password: string; fullName: string; organizationName: string; phone?: string }>();

  const onSubmit = async (values: { email: string; password: string; fullName: string; organizationName: string; phone?: string }) => {
    setError(null);
    try {
      const result = await partnerPortalApi.register(values);
      setMessage(result.data.message);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to register.');
    }
  };

  return (
    <div className="login-page">
      <div className="card" style={{ maxWidth: 460, margin: '60px auto', borderTop: '4px solid var(--vri-green)' }}>
        <h1>Partner Organization Registration</h1>
        <p className="muted">For staff of Verdantrise's partner organizations. Your registration will need to be verified by email and then reviewed by Verdantrise before you can sign in.</p>

        {message ? (
          <p>{message}</p>
        ) : (
          <form onSubmit={handleSubmit(onSubmit)}>
            <label>Full Name<input {...register('fullName', { required: true, minLength: 2 })} /></label>
            <label>Organization Name<input {...register('organizationName', { required: true, minLength: 2 })} placeholder="e.g. TCDI" /></label>
            <label>Email Address<input type="email" {...register('email', { required: true })} /></label>
            <label>Phone (optional)<input {...register('phone')} /></label>
            <label>Password<input type="password" {...register('password', { required: true, minLength: 8 })} /></label>
            {error && <p className="field-error">{error}</p>}
            <div className="form-actions"><button type="submit" disabled={isSubmitting}>{isSubmitting ? 'Registering…' : 'Register'}</button></div>
          </form>
        )}

        <p className="muted" style={{ fontSize: 13, marginTop: '1.5em' }}>Already have an account? <Link to="/login">Sign in</Link></p>
      </div>
    </div>
  );
}
